<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="$t('title.roles.delete')"
    :action-button-text="$t('button.remove')"
    color="gray"
    @actionConfirmed="onClickDeleteButton"
  >
    <OurTextBlock v-html="$t('page.roles.removeConfirm', { name: roleName })" />
  </OurConfirmModal>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";
import { deleteRoleMutation } from "./gql/mutations";

export default {
  name: "DeleteModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    roleId: {
      type: String,
      default: "",
    },

    roleName: {
      type: String,
      default: "",
    },

    delayNotify: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    closeModal() {
      this.isShownModal = false;
    },

    onClickCloseButton() {
      this.closeModal();
    },

    async onClickDeleteButton() {
      const { deleteRole } = await this.$post(deleteRoleMutation, { id: this.roleId });

      if (deleteRole.id) this.$emit("deleteRole");
    },
  },
};
</script>
